import { render, staticRenderFns } from "./resourceDetail.vue?vue&type=template&id=9afdee44&scoped=true&"
import script from "./resourceDetail.vue?vue&type=script&lang=js&"
export * from "./resourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./resourceDetail.vue?vue&type=style&index=0&id=9afdee44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afdee44",
  null
  
)

export default component.exports